import React from 'react';

export const TalkToJourneyThinking = () => {
  return (
    <div className="loader relative w-6 h-6">
      <div className="loader-dots">
        <div className="loader-dot bg-neue-journey-fg"></div>
        <div className="loader-dot bg-neue-journey-fg"></div>
        <div className="loader-dot bg-neue-journey-fg"></div>
      </div>
    </div>
  )
}